package com.anjuros.website.templates.template8.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType
import com.anjuros.website.templates.selection.util.Res


enum class ResKey: ResKeyType {

    TEMPLATE8_HOME,
    TEMPLATE8_INFO_1_TITLE,
    TEMPLATE8_INFO_DESC1,
    TEMPLATE8_INFO_BUTTON_TEXT1,
    TEMPLATE8_INFO_2_TITLE,
    TEMPLATE8_INFO_DESC2,
    TEMPLATE8_INFO_BUTTON_TEXT2,
    TEMPLATE8_INFO_3_TITLE,
    TEMPLATE8_INFO_DESC3,
    TEMPLATE8_INFO_BUTTON_TEXT3,
    TEMPLATE8_MON,
    TEMPLATE8_TUE_THU,
    TEMPLATE8_FRI_TO_SAT,
    TEMPLATE8_SUN,

    TEMPLATE8_SECTION1_PRODUCT1_TITLE,
    TEMPLATE8_SECTION1_PRODUCT1_DESC,
    TEMPLATE8_SECTION1_PRODUCT2_TITLE,
    TEMPLATE8_SECTION1_PRODUCT2_DESC,
    TEMPLATE8_SECTION1_PRODUCT3_TITLE,
    TEMPLATE8_SECTION1_PRODUCT3_DESC,

    // MAINS
    TEMPLATE8_SECTION2_PRODUCT1_TITLE,
    TEMPLATE8_SECTION2_PRODUCT1_DESC,
    TEMPLATE8_SECTION2_PRODUCT2_TITLE,
    TEMPLATE8_SECTION2_PRODUCT2_DESC,
    TEMPLATE8_SECTION2_PRODUCT3_TITLE,
    TEMPLATE8_SECTION2_PRODUCT3_DESC,

    // DESSERTS
    TEMPLATE8_SECTION3_PRODUCT1_TITLE,
    TEMPLATE8_SECTION3_PRODUCT1_DESC,
    TEMPLATE8_SECTION3_PRODUCT2_TITLE,
    TEMPLATE8_SECTION3_PRODUCT2_DESC,
    TEMPLATE8_SECTION3_PRODUCT3_TITLE,
    TEMPLATE8_SECTION3_PRODUCT3_DESC,

    // CATEGORIES
    TEMPLATE8_PRODUCT_SECTION1,
    TEMPLATE8_PRODUCT_SECTION2,
    TEMPLATE8_PRODUCT_SECTION3,

    TEMPLATE8_ABOUT1,
    TEMPLATE8_ABOUT2,
    TEMPLATE8_ABOUT3,
    TEMPLATE8_SERVICE1_TITLE,
    TEMPLATE8_SERVICE1_DESC1,
    TEMPLATE8_SERVICE1_DESC2,
    TEMPLATE8_SERVICE1_TIME,
    TEMPLATE8_SERVICE2_TITLE,
    TEMPLATE8_SERVICE2_DESC1,
    TEMPLATE8_SERVICE2_DESC2,
    TEMPLATE8_SERVICE2_TIME,
    TEMPLATE8_SERVICE3_TITLE,
    TEMPLATE8_SERVICE3_DESC1,
    TEMPLATE8_SERVICE3_DESC2,
    TEMPLATE8_SERVICE3_TIME,
    TEMPLATE8_SERVICE4_TITLE,
    TEMPLATE8_SERVICE4_DESC1,
    TEMPLATE8_SERVICE4_DESC2,
    TEMPLATE8_SERVICE4_TIME,
    TEMPLATE8_SERVICE4_TITLE0,

    TEMPLATE8_SLOGAN,
    TEMPLATE8_OPENING_HOURS;


    override val keyName: String
        get() = name
}


// 4. A map to hold all translations, keyed by language
val TextResources = mapOf(
    Language.EN to mapOf(

        ResKey.TEMPLATE8_HOME to "Home",
        ResKey.TEMPLATE8_INFO_1_TITLE to "Delicious Food & Drink",
        ResKey.TEMPLATE8_INFO_DESC1 to "Join us for a hearty meal and a pint of real ale. Browse our menu and discover a selection of classic pub favourites and seasonal specials.",
        ResKey.TEMPLATE8_INFO_BUTTON_TEXT1 to "View Menu",

        ResKey.TEMPLATE8_INFO_2_TITLE to "About the Pub",
        ResKey.TEMPLATE8_INFO_DESC2 to "Situated in the heart of the village, The Red Lion is a cosy, traditional British pub offering a warm welcome, real ales, and delicious home-cooked meals.",
        ResKey.TEMPLATE8_INFO_BUTTON_TEXT2 to "Learn More",

        ResKey.TEMPLATE8_INFO_3_TITLE to "What’s On",
        ResKey.TEMPLATE8_INFO_DESC3 to "Enjoy great drinks, live sport, and a warm, lively atmosphere every evening. From quiz nights to weekend DJs, there’s always something going on.", ResKey.TEMPLATE8_INFO_BUTTON_TEXT3 to "What's On",
        ResKey.TEMPLATE8_MON to "Monday",
        ResKey.TEMPLATE8_TUE_THU to "Tuesday - Thursday",
        ResKey.TEMPLATE8_FRI_TO_SAT to "Friday - Saturday",
        ResKey.TEMPLATE8_SUN to "Sunday",
        // STARTERS
        ResKey.TEMPLATE8_SECTION1_PRODUCT1_TITLE to "Bruschetta",
        ResKey.TEMPLATE8_SECTION1_PRODUCT1_DESC to "Grilled bread with tomatoes and basil",
        ResKey.TEMPLATE8_SECTION1_PRODUCT2_TITLE to "Soup of the Day",
        ResKey.TEMPLATE8_SECTION1_PRODUCT2_DESC to "Fresh seasonal soup served with bread",
        ResKey.TEMPLATE8_SECTION1_PRODUCT3_TITLE to "Chicken Wings",
        ResKey.TEMPLATE8_SECTION1_PRODUCT3_DESC to "Spicy wings with blue cheese dip",

        // MAINS
        ResKey.TEMPLATE8_SECTION2_PRODUCT1_TITLE to "Beef Burger",
        ResKey.TEMPLATE8_SECTION2_PRODUCT1_DESC to "Juicy beef burger with lettuce and tomato",
        ResKey.TEMPLATE8_SECTION2_PRODUCT2_TITLE to "Grilled Salmon",
        ResKey.TEMPLATE8_SECTION2_PRODUCT2_DESC to "Salmon fillet with lemon butter sauce",
        ResKey.TEMPLATE8_SECTION2_PRODUCT3_TITLE to "Veggie Pasta",
        ResKey.TEMPLATE8_SECTION2_PRODUCT3_DESC to "Pasta with seasonal vegetables and tomato sauce",

        // DESSERTS
        ResKey.TEMPLATE8_SECTION3_PRODUCT1_TITLE to "Chocolate Cake",
        ResKey.TEMPLATE8_SECTION3_PRODUCT1_DESC to "Rich chocolate cake with cream",
        ResKey.TEMPLATE8_SECTION3_PRODUCT2_TITLE to "Ice Cream",
        ResKey.TEMPLATE8_SECTION3_PRODUCT2_DESC to "Three scoops of your choice",
        ResKey.TEMPLATE8_SECTION3_PRODUCT3_TITLE to "Fruit Tart",
        ResKey.TEMPLATE8_SECTION3_PRODUCT3_DESC to "Seasonal fruit tart with custard",

        // CATEGORIES
        ResKey.TEMPLATE8_PRODUCT_SECTION1 to "Starters",
        ResKey.TEMPLATE8_PRODUCT_SECTION2 to "Mains",
        ResKey.TEMPLATE8_PRODUCT_SECTION3 to "Desserts",

        ResKey.TEMPLATE8_ABOUT1 to
                "Situated in the heart of the village, The Red Lion is a charming and welcoming traditional British pub that has been a favourite among locals and visitors alike for generations. Step inside and you’ll be greeted by a warm, inviting atmosphere, with rustic wooden beams, a roaring fire in the colder months, and friendly staff who make everyone feel at home.",

        ResKey.TEMPLATE8_ABOUT2 to
                "The pub prides itself on offering a carefully selected range of real ales, locally sourced craft beers, and a fine selection of wines and spirits to suit every taste. The kitchen serves delicious home-cooked meals, from hearty pub classics such as beef burgers and grilled salmon to lighter options and seasonal specials, all prepared using fresh, locally sourced ingredients.",

        ResKey.TEMPLATE8_ABOUT3 to
                "Whether you’re popping in for a quick pint after work, meeting friends for a leisurely lunch, or celebrating a special occasion, The Red Lion provides the perfect setting. With regular live music, quiz nights, and community events, it’s not just a place to eat and drink. It’s a true hub of village life. Come and enjoy the friendly atmosphere, excellent food, and traditional charm that have made The Red Lion a much-loved part of the community.",
        ResKey.TEMPLATE8_SERVICE1_TITLE to "MONDAY PUB QUIZ",
        ResKey.TEMPLATE8_SERVICE1_DESC1 to "Join our weekly classic quiz from 8 PM.",
        ResKey.TEMPLATE8_SERVICE1_DESC2 to "Prizes and fun!",
        ResKey.TEMPLATE8_SERVICE1_TIME to "8pm - 10:30pm",
        ResKey.TEMPLATE8_SERVICE2_TITLE to "WEDNESDAY STEAK NIGHT",
        ResKey.TEMPLATE8_SERVICE2_DESC1 to "Two steaks + a bottle of wine for £35.",
        ResKey.TEMPLATE8_SERVICE2_DESC2 to "Delicious local steaks cooked to perfection.",
        ResKey.TEMPLATE8_SERVICE2_TIME to "From 6pm",
        ResKey.TEMPLATE8_SERVICE3_TITLE to "FRIDAY LIVE MUSIC",
        ResKey.TEMPLATE8_SERVICE3_DESC1 to "Featuring local bands and artists every Friday.",
        ResKey.TEMPLATE8_SERVICE3_DESC2 to "Check our socials for lineups.",
        ResKey.TEMPLATE8_SERVICE3_TIME to "9pm onwards",
        ResKey.TEMPLATE8_SERVICE4_TITLE to "SUNDAY ROASTS",
        ResKey.TEMPLATE8_SERVICE4_DESC1 to "Our legendary Sunday lunch.",
        ResKey.TEMPLATE8_SERVICE4_DESC2 to "Reservation highly recommended.",
        ResKey.TEMPLATE8_SERVICE4_TIME to "12pm - 5pm",
        ResKey.TEMPLATE8_SERVICE4_TITLE0 to "What's on at The Red Lion",

        ResKey.TEMPLATE8_SLOGAN to "Real Ales, Great Food, True British Charm",
        ResKey.TEMPLATE8_OPENING_HOURS to "Opening Hours:",
        ),
)
